module.exports = __webpack_public_path__ + "static/media/sketch-inverted-cvo-limited.b38095c0.png";